var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"word-list11"},[_c('div',{staticClass:"head",style:({
      backgroundImage: 'url(' + _vm.dataInfo.cover + ')'
    })},[_vm._v(" "+_vm._s(_vm.dataInfo.name)+" ")]),_c('div',{staticClass:"g-box"},[_c('RecList')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }